import { Sale } from '@utilities/types';
import React, { createContext, useState, PropsWithChildren } from 'react';

interface SalesContextType {
    sales: Sale[];
    setSales: React.Dispatch<React.SetStateAction<Sale[]>>;
    selectedSale: Sale | null;
    setSelectedSale: React.Dispatch<React.SetStateAction<Sale | null>>;
}

export const SalesContext = createContext<SalesContextType>({
    sales: [],
    setSales: () => {},
    selectedSale: null,
    setSelectedSale: () => {}
});

export const SalesContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [sales, setSales] = useState<Sale[]>([]);
    const [selectedSale, setSelectedSale] = useState<Sale | null>(null);

    return (
        <SalesContext.Provider value={{
            sales, setSales,
            selectedSale, setSelectedSale
        }}>
            {children}
        </SalesContext.Provider>
    );
};
